import { useCallback, useState } from "react";

interface UseOnboardingLoadingReturn {
	isLoading: boolean;
	executeWithLoading: <T>(
		operation: () => Promise<T>,
		minLoadingTime?: number,
	) => Promise<T>;
}

export function useOnboardingLoading(): UseOnboardingLoadingReturn {
	const [isLoading, setIsLoading] = useState(false);

	const executeWithLoading = useCallback(
		async <T>(
			operation: () => Promise<T>,
			minLoadingTime = 1200,
		): Promise<T> => {
			setIsLoading(true);

			try {
				const startTime = Date.now();
				const result = await operation();

				const elapsed = Date.now() - startTime;
				if (elapsed < minLoadingTime) {
					const waitTime = minLoadingTime - elapsed;
					await new Promise((resolve) => setTimeout(resolve, waitTime));
				}

				setIsLoading(false);
				return result;
			} catch (error) {
				setIsLoading(false);
				throw error;
			}
		},
		[],
	);

	return {
		isLoading,
		executeWithLoading,
	};
}
